import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Box, Text } from "@theme-ui/components"

// Begin swiper
import SwiperCore, { Pagination, Mousewheel, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"
import { useBreakpointIndex } from "@theme-ui/match-media"
import { OutboundLink } from "../link"
SwiperCore.use([Mousewheel, Pagination, A11y])
// End swiper

const ImageGallery = ({ images }) => {
  const mediaIndex = useBreakpointIndex()
  return (
    <Box
      sx={{
        ".swiper-slide": {
          height: "auto",
        },
      }}
    >
      {images.length > 1 ? (
        <Swiper
          spaceBetween={16}
          draggable={true}
          mousewheel={{
            forceToAxis: true,
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.2,
            },
            640: {
              slidesPerView: images.length > 2 ? 2.2 : images.length,
            },
            896: {
              slidesPerView: images.length > 2 ? 2.2 : images.length,
            },
          }}
          freeMode={true}
          autoHeight={false}
        >
          {images.map(image => (
            <SwiperSlide key={image.originalId}>
              <StyledImage image={image} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <StyledImage image={images[0]} />
      )}
    </Box>
  )
}

const StyledImage = ({ image }) => {
  const ImageContainer = image.customData && image.customData.url ? OutboundLink : Box

  return (
    <>
      <ImageContainer
        href={ image.customData && image.customData.url && image.customData.url}
        sx={{
          height: "100%",
          width: "100%",
          mb: 2,
          ".gatsby-image-wrapper": {
            height: "100%",
            width: "100%",
            border: "1px solid",
            borderColor: "lightGrey",
            img: {
              width: "100%",
              maxHeight: "605px",
              objectFit: "contain!important",
            },
          },
        }}
      >
        <GatsbyImage image={image.gatsbyImageData} alt="" />
      </ImageContainer>
      <Box>
        <Text variant="caption">{image.title}</Text>
      </Box>
    </>
  )
}

export default ImageGallery
